import SingleBox from "Dashboard/Overview/firstSection/Box";
import { useHistory } from "react-router-dom";
import { BoxContainer } from "./styled";
import FPIcon from "Assets/FPIcon.svg";
import ThirdIcon from "Assets/ThirdIcon.svg";
import PlusIcon from "Assets/PlusIcon.svg";

const TopBox = () => {
  const history = useHistory();
  const boxData = [
    {
      id: 1,
      title: "FountainPay",
      icon: FPIcon,
      background: false,
      // urlPath: "business",
      value: "25,000,000.00",
    },
    {
      id: 2,
      title: "Third Party",
      icon: ThirdIcon,
      background: false,
      // urlPath: "business",
      value: "25,000,000.00",
    },
    // {
    //   id: 3,
    //   title: "Add third party",
    //   icon: PlusIcon,
    //   background: false,
    //   urlPath: "./third-party",
    // },
  ];

  const boxLists = boxData.map((box) => {
    // let check = ![1, 4].includes(box?.id);
    return (
      <SingleBox
        // noPointer={false}
        style={{ width: "45%" }}
        boxValueStyle={{ fontSize: "0.9rem" }}
        key={box.id}
        boxdata={box}
        boxIconStyle={box.id === 3 ? { marginTop: "2rem" } : {}}
        // onClick={() => box?.urlPath && history.push(box?.urlPath)}
        // isLoading={isLoading}
      />
    );
  });
  return <BoxContainer>{boxLists}</BoxContainer>;
};
export default TopBox;
